import React, { useState } from 'react'
import axios from 'axios'
import { getOrCreateClientId } from '../../context/clientIdHelper';
import { containsProfanities } from '../../shared/utils/ContainsProfanity';


const API = process.env.REACT_APP_API_URL;
const PLACEHOLDER_NAMES = new Set(['flashroom user', 'owner']);

function isPlaceholderName(name: string) {
    return PLACEHOLDER_NAMES.has(name.trim().toLowerCase());
}

type AddNameProps = {
    setAccountPrompt: React.Dispatch<React.SetStateAction<boolean>>;
};

const AddName: React.FC<AddNameProps> = ({ setAccountPrompt }) => {

    const KEY_ID = 'flashroom-accountId';
    const KEY_NAME = 'flashroom-accountName';


    const [Name, setUsername] = useState('');
    const [error, setError] = useState('');

    const handleNameSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const name = Name.trim();
        setError('');

        if (!name || isPlaceholderName(name)) {
            setError('Enter your name to continue.');
            return;
        }

        if (containsProfanities(name)) {
            setError('Choose a different display name.');
            return;
        }

        try {
            const clientId = getOrCreateClientId();
            const { data } = await axios.post(`${API}/api/users`, { name, clientId });
            const id = data?.user?.id;
            if (!id) throw new Error('No user id in response');

            localStorage.setItem(KEY_NAME, name);
            localStorage.setItem(KEY_ID, id); // id is already a string
            setAccountPrompt(false);
        } catch (err) {
            setError('Unable to save your name. Please try again.');
        }
    };
    return (
        <div id="name-prompt" className="shareable-name-card">
            <h3>What is your name?</h3>

            <form id="nameform" onSubmit={handleNameSubmit}>
                <input maxLength={20} type='text' value={Name} onChange={(e) => {
                    setUsername(e.target.value);
                    setError('');
                }} placeholder='enter your name' />
                {error && <p className="join-error" role="alert">{error}</p>}
                <button type='submit'>Submit</button>

            </form>
        </div>
    )
}

export default AddName
